import { RouterContext } from '../../libs/gs-component-right-rail';
import Icon from '@xo-union/tk-component-icons';
import { Body1 } from '@xo-union/tk-ui-typography';
import { Snackbar } from '@xo-union/tk-component-alerts';
import React, { useContext, useRef } from 'react';

import { Maybe } from '../../generated/graphql';
import useWWSUrl from '../../helpers/useWWSUrl';
import LinkButton from '../LinkButton';
import styles from './header.scss';
import UrlCopy from '../InfoHeader/UrlCopy';
import { SnackbarInterface, DISMISS_TIMEOUT } from '../../helpers/snackbar';
import { Section } from './Section';

interface Props {
  vanityUrl?: Maybe<string>;
  showVanityUrl?: boolean;
}

export const Url: React.FC<Props> = ({ vanityUrl, showVanityUrl = true }) => {
  const url = useWWSUrl();
  const { push } = useContext(RouterContext);

  const snackbar = useRef<SnackbarInterface>();

  const wwsUrlCopiedEvent = () => {
    if (snackbar?.current) {
      snackbar.current.showAndDismiss({
        data: 'Website link copied',
        dismissTimeout: DISMISS_TIMEOUT,
      });
    }
  };

  return (
    <Section>
      <Body1 className={styles.urlWrapper}>
        <div className={styles.url}>{url}</div>
        {showVanityUrl && (
          <LinkButton
            color="primary"
            onClick={() => push({ screen: 'url', params: { vanityUrl } })}
            className={styles.editButton}
          >
            <Icon data-testid="wws-url-edit-icon" name="edit" />
          </LinkButton>
        )}
        <UrlCopy url={url} onCopy={wwsUrlCopiedEvent} copyCta="Copy link" className={styles.copyLink} />
      </Body1>
      <Snackbar ref={snackbar} />
    </Section>
  );
};
